import { axios } from '@/lib/axios';

type TUpdateAlertApi = {
    message: string | undefined;
    active: boolean;
};
export const updateAlertApi = (data: TUpdateAlertApi) =>
    axios.post(`/v1/update-alert`, data).then((res) => res);
